// extracted by mini-css-extract-plugin
module.exports = {"how-it-works-steps":"HowItWorksSteps_how-it-works-steps__hCd9Y"};